import { isCmhub, microAppSides } from './config';
import { getUnifiedAuth, saveUnifiedAuth, clearUnifiedAuth } from './session';
import { getCmhubPermissions, clearCmhubResources } from './resources';
import { validateSide, instanceKey } from './navigation';

const copy = (value) => JSON.parse(JSON.stringify(value));

export const createCmhubContext = (appName, onInvalidated = () => {}, explicitSide) => {
  if (!isCmhub()) return undefined;
  const side = explicitSide === undefined ? microAppSides[appName] : validateSide(appName, explicitSide);
  if (!side) throw new Error(`尚未配置微应用的客商归属：${appName}`);
  const initial = getUnifiedAuth();
  const issued = initial && initial[side];
  if (!issued || !issued.available) throw new Error(`${side === 'customer' ? '客' : '商'}系统登录不可用，请重新登录`);
  const { token, accountId, tenantId } = issued;
  const env = localStorage.getItem('curEnv');
  const getIdentity = () => {
    if (!isCmhub() || env !== localStorage.getItem('curEnv')) return null;
    const current = getUnifiedAuth();
    const identity = current && current[side];
    return identity && identity.available && identity.token === token
      && identity.accountId === accountId && identity.tenantId === tenantId ? copy(identity) : null;
  };
  const baseURL = side === 'customer' && initial.customerAuthMode === 'private'
    ? process.env.VUE_APP_CMHUB_CUSTOMER_BASE_URL
    : `/boss${process.env.NODE_ENV === 'development' && env ? `/${env}` : ''}`;
  if (!baseURL) throw new Error('未配置私有客系统接口地址');
  const getPermissions = () => (getIdentity() ? copy(getCmhubPermissions(side)) : []);
  return Object.freeze({
    enabled: true,
    side,
    baseURL,
    customerAuthMode: initial.customerAuthMode,
    getIdentity,
    getPermissions,
    hasPermission: (code) => getPermissions().some((item) => item.resourceCode === code),
    onAuthExpired: (reportedSide, code) => {
      if (reportedSide !== side || !getIdentity()) return;
      const current = getUnifiedAuth();
      current[side] = { available: false, errorCode: String(code || 'AUTH_INVALID') };
      clearCmhubResources();
      if (current.customer.available || current.merchant.available) {
        current.status = 'PARTIAL';
        saveUnifiedAuth(current);
      } else {
        clearUnifiedAuth();
      }
      onInvalidated(side);
    },
  });
};

export const withCmhubProps = (config, registeredApps, onInvalidated, side) => {
  if (!isCmhub()) return config;
  // 嵌套实例可以带唯一后缀，但必须仍指向基座注册的应用入口。
  const registered = registeredApps.find((app) => (
    (config.name === app.name || config.name.startsWith(`${app.name}_embedded_`)
      || (side && (config.name === instanceKey(app.name, side)
        || config.name.startsWith(`${instanceKey(app.name, side)}_embedded_`))))
    && config.entry === app.entry
  ));
  if (!registered) throw new Error('融合微应用未注册或入口地址不匹配');
  return {
    ...config,
    props: { ...config.props, cmhub: createCmhubContext(registered.name, onInvalidated, side) },
  };
};
